"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SortButton = void 0;
var React = require("react");
var recompose_1 = require("recompose");
var classNames = require("classnames");
var __1 = require("../../../");
function toggleOrder(order) {
    if (order === 'asc') {
        return 'desc';
    }
    if (order === 'desc') {
        return undefined;
    }
    return 'asc';
}
function getOrderIcon(order) {
    if (order === 'asc') {
        return React.createElement(__1.Icon, { className: "fa-sort-up" });
    }
    if (order === 'desc') {
        return React.createElement(__1.Icon, { className: "fa-sort-down" });
    }
    return React.createElement(__1.Icon, { className: "fa-sort" });
}
var enhance = (0, recompose_1.compose)((0, recompose_1.setDisplayName)('SortButton'), recompose_1.pure);
exports.SortButton = enhance(function (_a) {
    var children = _a.children, className = _a.className, order = _a.order, onChange = _a.onChange, disabled = _a.disabled;
    return (React.createElement("button", { className: classNames('sok-sort-button', className), onClick: function () {
            return typeof onChange === 'function' &&
                !disabled &&
                onChange(toggleOrder(order));
        }, disabled: disabled },
        React.createElement("span", { className: "sok-sort-button__text" }, children),
        !disabled && (React.createElement("span", { className: "sok-sort-button__icon" }, getOrderIcon(order)))));
});
//# sourceMappingURL=index.js.map